import React, {Component} from "react";
//import {TableComp} from 'sz-react-utils'
import moment from "moment";
import {
    Card,
    Button,
    notification,
    Drawer,
    Table,
    Tooltip,
    Checkbox
  } from "antd";
  import WhatsAppSms from "../../components/communication/WhatsAppSms";
import Request from "../../request";
import styles from "../../containers/Desk/counselling/all//styles.less";

import {connect} from "react-redux";
import lodash from 'lodash'

import rightAuth from "../../components/_utils/userRights";
import {hideLoader, showLoader} from '../../modules/actions';

let userCheckBox = {};
let counsellingData = {};

class DashboardStudentList extends Component {
    state = {
        visible: true,
        arr: [],
        userCheckBox: {},
        showWhatsAppSms: false
    };

    onOk = (value) => {
        this.reload();
    };
    reload = () => {
        this.table.current.reload();
    };
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked === true?item:false);
        })
  
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({showWhatsAppSms: true})
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeWhatsSMS = () => {
        this.setState({showWhatsAppSms: false})
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] === undefined) {
          cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({userCheckBox: cloneUserCheckBox})
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({userCheckBox: cloneUserCheckBox})
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({userCheckBox: cloneUserCheckBox})
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    componentDidMount() {    
        this.loadDashboardCallLogs();
    }

    onClose = () => {
        this.setState({
            visible: false,
        });

        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };

    loadDashboardCallLogs = async () => {
        this.setState({loading: true});
        let response = await Request.loadDashboardCallLogs({
            callType: this.props.param.callType,
            results: 10000,
        });

        if (response) {
            lodash.each(response.data, (item) => {
                if (!userCheckBox[item._id]) {
                  userCheckBox[item._id] = {
                    _id: item._id,
                    mobile: item.callerNumberRaw,
                    isChecked: false
                  }
                }
            })
            this.setState({arr: response.data, userCheckBox: userCheckBox});
        }
        this.setState({loading: false});
    };

    render() {
        let {arr} = this.state;
        const { dispatch } = this.props;
        
        const columns = [
            {
              title: 'Client Number',
              key: 'callerNumber',
              width: '200px',
              render: (text, record) => {
                return (
                  <div>
                    <Tooltip title="Select">
                        <span>
                            <Checkbox
                                checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                                onChange={y => {
                                    this.selectUser(y, record._id)
                                }}>
                            </Checkbox>
                        </span>
                    </Tooltip>&nbsp;
                    {rightAuth.checkRights("ShowClickToCall.view") ? (
                    <Tooltip title="Start Call">
                      <Button
                          className='ant-btn ant-btn-primary'
                          onClick={(e) => {
                              dispatch(showLoader())
                              Request.callInitiate({
                              mobile: record.callerNumberRaw,
                              
                              }).then(({data, error, message}) => {
                                  dispatch(hideLoader())
                                  if (!error) {
                                      notification.success({
                                          message: message
                                      })
                                  } else {
                                      notification.error({
                                          message: message
                                      })
                                  }
                              })
                          }}
                      >
                       {record.callerNumber} <br />Click To Call
                      </Button>
                    </Tooltip>
                  ) : (
                    record.callerNumberRaw
                  )}</div>
                )
              }
            },
            {
              title: 'Agent Number',
              key: 'callerFromNumber',
              render: (text, record) => {
                return (
                    <div>{record.callerFromNumber}</div>
                )
              }
            },
            {
              title: 'Start Time',
              key: 'startTime',
              render: (text, record) => {
                var startTime = new Date(record.startTime * 1000);
                return (
                  <div>
                    {
                      record.startTime ? 
                        <div>{moment(startTime).format('lll')}</div>
                      : 'NA'
                    }              
                  </div>
                )
              }
            },
            {
              title: 'End Time',
              key: 'endTime',
              render: (text, record) => {
                var endTime = new Date(record.endTime * 1000);
                return (
                  <div>
                    {
                      record.endTime ? 
                        <div>{moment(endTime).format('lll')}</div>
                      :'NA'
                    }              
                  </div>
                )
              }
            },
            {
              title: 'Log Message',
              key: 'logMessage',
              width: '300px',
              render: (text, record) => {
                return (
                    <div>{record.logMessage}</div>
                )
              }
            },
            {
              title: 'Duration',
              key: 'duration',
              render: (text, record) => {
                return (
                    <div>{record.duration}</div>
                )
              }
            },
            {
              title: 'call Initiated By',
              key: 'callInitiatedBy',
              dataIndex: 'callInitiatedBy',
              render: (text, record) => {
                return (
                  <div>
                    <div>{record.callInitiatedBy != null ? record.callInitiatedBy.name : ""}</div>
                    <small>{record.callInitiatedBy ? moment(record.callInitiatedBy.time).format('lll') : '' }</small>
                  </div>
                )
              }
            }
        ];

        return (
            <Drawer
                title={`${this.props.param.title} (${this.props.param.count})`}
                placement="right"
                closable={true}
                onClose={() => this.onClose()}
                visible={this.state.visible}
                width={1000}
            >
                <div>
                    {this.state.showWhatsAppSms ? (
                        <WhatsAppSms counsellingData={counsellingData} onClose={this.closeWhatsSMS}/>
                    ) : null}
                    <Card style={{marginBottom: 10}}>
                        <div className={styles.filterBlock}>
                            <div className={styles.myBtnGroup}>
                                <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                                    <Button
                                        type="primary"
                                        className={styles.btn}
                                        onClick={() => this.showWhatsAppSms()}>Send Whatsapp SMS
                                    </Button>
                                    <Button
                                        className={styles.btn}
                                        onClick={() => this.selectAllUserFxn()}>Select Visible
                                    </Button>
                                    <Button
                                        className={styles.btn}
                                        onClick={() => this.unselectAllUserFxn()}>UnSelect Visible
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card>
                    <Table
                        showHeader={true}
                        dataSource={arr}
                        columns={columns}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                        loading={this.state.loading}
                    />
                </div>
            </Drawer>
        );
    }
}

const mapStateToProps = ({global, router}) => ({
    categories: global.categories,
    search: router.location.search,
    currentUser: global.currentUser,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardStudentList);
